module.exports = __webpack_public_path__ + "img/5-6.5679e93d.png";